import Footer from "../footer/footer";
import Navbar from "../navbar/navbar";
import rotary from "../../assets/Rotary Screw Compressor.png";
import Reciprocating from "../../assets/Reciprocating Air Compressor.png";
import Centrifugal from "../../assets/Centrifugal Compressor.png";
import high from "../../assets/hsr compressor.jpg";
import Axial from "../../assets/Axial Compressor.png";
import Banner from "../../assets/compressor.png";
import 'aos/dist/aos.css'
import { Helmet } from "react-helmet";
import React from "react";
import {
    FaIndustry,
    FaGasPump,
    FaTools,
    FaShippingFast,
    FaCertificate,
    FaCogs,
    FaChartLine,
    FaShieldAlt,
    FaHeadset,
    FaCubes,
    FaCheck
} from "react-icons/fa";
import { FaOilWell } from "react-icons/fa6";
import { HiOutlineBadgeCheck } from "react-icons/hi";

const Compressors: React.FC = () => {
    return (
        <><Helmet>
            <title>Industrial Air Compressors Manufacturer, Supplier & Exporter | Rotary Screw, Reciprocating & Centrifugal
            </title>
            <meta
                name="description"
                content="City Cat International supplies high-quality industrial air compressors: Rotary, Reciprocating, Centrifugal & Axial for oil, gas, and energy applications."
            />

            <meta
                name="keywords"
                content="industrial air compressors manufacturer India, rotary screw compressor exporter, reciprocating compressor supplier India, centrifugal compressor manufacturer, axial flow compressor exporter, high-speed reciprocating compressors, industrial air systems supplier, oil and gas compressors India, compressor spare parts exporter, City Cat International"/>
                
            <meta name="robots" content="index, follow" />
            <link rel="canonical" href="https://www.oilandgasindustrialequipmentsupply.com/oil-gas-compressors" />

            <meta property="og:title" content="Premium Industrial Compressors Manufacturer & Global Supplier" />
            <meta property="og:description" content="Exporting high-performance compressors to 45+ countries. ISO-certified manufacturing with 30+ years expertise in industrial compressed air solutions." />
            <meta property="og:image" content="https://www.oilandgasindustrialequipmentsupply.com/assets/compressors-banner.jpg" />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="Industrial Compressors for Oil & Gas Operations | City Cat International" />
            <meta name="twitter:description" content="Global supplier of API 618/11P compliant compressors for offshore platforms, refineries & pipeline operations. Request technical specs." />

            <script type="application/ld+json">
                {`
                {
                  "@context": "https://schema.org",
                  "@type": "ProductPage",
                  "name": "Industrial Compressors",
                  "description": "Manufacturer and exporter of premium industrial compressors for global operations",
                  "url": "https://www.oilandgasindustrialequipmentsupply.com/oil-gas-compressors",
                  "image": "https://www.oilandgasindustrialequipmentsupply.com/assets/compressors-banner.jpg",
                  "brand": {
                    "@type": "Brand",
                    "name": "City Cat International"
                  },
                  "manufacturer": {
                    "@type": "Organization",
                    "name": "City Cat International"
                  }
                }
                `}
            </script>
        </Helmet>

            <Navbar />

            {/* Hero Banner */}
            <div className="relative bg-gray-900 mt-24">
                <img
                    src={Banner}
                    alt="Industrial Compressors for Oil & Gas Operations"
                    className="w-full h-96 object-cover opacity-70"
                />
                <div className="absolute inset-0 flex flex-col justify-center items-center text-center px-4">
                    <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
                        Industrial Compressor Solutions for Global Operations
                    </h1>
                    <p className="text-xl text-white max-w-3xl">
                        Premium Rotary, Reciprocating, Centrifugal & Axial Compressors for Oil & Gas, Manufacturing & Energy Sectors
                    </p>
                </div>
            </div>

            {/* Industries Served Section */}
            <section className="py-16 bg-gray-50">
                <div className="container mx-auto px-4">
                    <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
                        Compressors for Critical Industries
                    </h2>

                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 max-w-5xl mx-auto">
                        {[
                            { icon: <FaOilWell />, name: "Oil Exploration" },
                            { icon: <FaGasPump />, name: "Gas Processing" },
                            { icon: <FaIndustry />, name: "Refineries" },
                            { icon: <FaTools />, name: "Manufacturing" },
                            { icon: <FaShippingFast />, name: "Marine & Offshore" },
                            { icon: <FaCertificate />, name: "Power Generation" }
                        ].map((industry, index) => (
                            <div key={index} className="bg-white p-6 rounded-lg shadow-sm text-center">
                                <div className="text-rose-600 text-3xl mb-3 flex justify-center">
                                    {industry.icon}
                                </div>
                                <h3 className="font-semibold text-gray-800">{industry.name}</h3>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Comprehensive Solutions Section */}
            <section className="py-16 bg-white">
                <div className="container mx-auto px-4">
                    <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
                        Comprehensive Compressor Solutions
                    </h2>

                    <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6 max-w-6xl mx-auto">
                        {[
                            {
                                icon: <FaCogs className="text-4xl mb-4" />,
                                title: "Custom Engineering",
                                desc: "Bespoke designs for specific pressure, flow & environmental requirements"
                            },
                            {
                                icon: <FaChartLine className="text-4xl mb-4" />,
                                title: "Performance Monitoring",
                                desc: "Remote IoT-enabled systems for real-time compressor health tracking"
                            },
                            {
                                icon: <FaShieldAlt className="text-4xl mb-4" />,
                                title: "Safety Compliance",
                                desc: "ATEX, IECEx & API certified units for hazardous environments"
                            },
                            {
                                icon: <FaHeadset className="text-4xl mb-4" />,
                                title: "24/7 Support",
                                desc: "Global technical assistance with average 4-hour response time"
                            },
                            {
                                icon: <FaCubes className="text-4xl mb-4" />,
                                title: "Spare Parts Network",
                                desc: "Genuine components available from 12 global warehouses"
                            }
                        ].map((feature, index) => (
                            <div key={index} className="bg-gray-50 p-6 rounded-lg text-center">
                                <div className="text-rose-600 flex justify-center">{feature.icon}</div>
                                <h3 className="text-xl font-bold text-gray-900 mb-2">{feature.title}</h3>
                                <p className="text-gray-700">{feature.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <div className="bg-white">
                <h2 className="text-center text-gray-800 text-4xl lg:text-5xl font-bold leading-tight pt-16">
                    Compressor Range
                </h2>
                <div className="my-4 mx-auto w-16 h-2 border-4 border-rose-600 mb-20"></div>

                {/* Rotary Screw Compressor */}
                <section data-aos="fade-right">
                    <div className="mx-auto max-w-screen-xl px-4 py-8 sm:px-6 sm:py-12 lg:px-8 lg:py-16">
                        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-16">
                            <div className="relative h-64 overflow-hidden rounded-lg sm:h-80 lg:order-last lg:h-full">
                                <img
                                    alt="Rotary Screw Air Compressor for industrial applications"
                                    src={rotary}
                                    className="absolute inset-0 h-full w-full object-contain" />
                            </div>

                            <div className="lg:py-16">
                                <h2 className="text-4xl text-gray-800 text-center font-bold sm:text-4xl">
                                    Rotary Screw Compressors
                                </h2>

                                <div className="my-6">
                                    <h3 className="text-xl font-semibold text-rose-600 mb-2">Key Specifications:</h3>
                                    <ul className="list-disc pl-5 text-gray-700 space-y-1">
                                        <li>Flow Range: 10-5,000 CFM</li>
                                        <li>Pressure: 7-500 PSIG</li>
                                        <li>Power: 5-600 HP</li>
                                        <li>Oil-free and lubricated models</li>
                                    </ul>
                                </div>

                                <p className="mt-4 text-gray-600 text-lg text-justify">
                                    Our rotary screw compressors deliver reliable compressed air with industry-leading
                                    energy efficiency. Featuring advanced airend designs with asymmetric profiles, these
                                    compressors reduce energy consumption by up to 15% compared to conventional models.
                                    Ideal for continuous operations in manufacturing plants, automotive facilities, and
                                    food processing units where clean, dry air is critical.
                                </p>

                                <div className="mt-8 flex justify-center">
                                    <a
                                        href="/contact"
                                        className="inline-block rounded bg-rose-600 px-8 py-3 text-md font-medium text-white transition hover:bg-rose-700 focus:outline-none focus:ring focus:ring-rose-300"
                                    >
                                        Request Technical Specs
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Reciprocating Air Compressor */}
                <section data-aos="fade-left">
                    <div className="mx-auto max-w-screen-xl px-4 py-8 sm:px-6 sm:py-12 lg:px-8 lg:py-16">
                        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-16">
                            <div className="relative h-64 overflow-hidden rounded-lg sm:h-80 lg:order-first lg:h-full">
                                <img
                                    alt="Industrial Reciprocating Air Compressor for high-pressure applications"
                                    src={Reciprocating}
                                    className="absolute inset-0 h-full w-full object-contain" />
                            </div>

                            <div className="lg:py-16">
                                <h2 className="text-center text-gray-800 text-4xl font-bold sm:text-4xl">
                                    Reciprocating Air Compressors
                                </h2>

                                <div className="my-6">
                                    <h3 className="text-xl font-semibold text-rose-600 mb-2">Key Specifications:</h3>
                                    <ul className="list-disc pl-5 text-gray-700 space-y-1">
                                        <li>Pressure: 100-6,000 PSIG</li>
                                        <li>Stages: 1-5 stage configurations</li>
                                        <li>Capacity: 0.5-1,500 CFM</li>
                                        <li>Explosion-proof models available</li>
                                    </ul>
                                </div>

                                <p className="mt-4 text-gray-600 text-lg text-justify">
                                    Engineered for high-pressure industrial applications, our reciprocating compressors
                                    feature reinforced cast iron construction with advanced valve technology for extended
                                    service life. Designed to API 618 standards, these workhorses deliver exceptional
                                    performance in petrochemical plants, refineries, and gas transmission facilities.
                                    Optional VFD control reduces energy consumption during partial load operation.
                                </p>

                                <div className="mt-8 flex justify-center">
                                    <a
                                        href="/contact"
                                        className="inline-block rounded bg-rose-600 px-8 py-3 text-md font-medium text-white transition hover:bg-rose-700 focus:outline-none focus:ring focus:ring-rose-300"
                                    >
                                        Get Pressure-Specific Quote
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Centrifugal Compressor */}
                <section data-aos="fade-right">
                    <div className="mx-auto max-w-screen-xl px-4 py-8 sm:px-6 sm:py-12 lg:px-8 lg:py-16">
                        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-16">
                            <div className="relative h-64 overflow-hidden rounded-lg sm:h-80 lg:order-last lg:h-full">
                                <img
                                    alt="Centrifugal Compressor for large-scale industrial applications"
                                    src={Centrifugal}
                                    className="absolute inset-0 h-full w-full object-contain" />
                            </div>

                            <div className="lg:py-16">
                                <h2 className="text-4xl text-gray-800 text-center font-bold sm:text-4xl">
                                    Centrifugal Compressors
                                </h2>

                                <div className="my-6">
                                    <h3 className="text-xl font-semibold text-rose-600 mb-2">Key Specifications:</h3>
                                    <ul className="list-disc pl-5 text-gray-700 space-y-1">
                                        <li>Flow: 1,000-150,000 m³/h</li>
                                        <li>Pressure: 3-50 bar</li>
                                        <li>Integrally geared designs</li>
                                        <li>ISO 10440 & API 617 compliant</li>
                                    </ul>
                                </div>

                                <p className="mt-4 text-gray-600 text-lg text-justify">
                                    Our centrifugal compressors deliver massive air volumes with unmatched efficiency.
                                    Featuring advanced aerodynamics with 3D impeller designs, these units achieve
                                    isentropic efficiencies up to 85%. Magnetic bearings and dry gas seal options
                                    eliminate oil contamination, making them ideal for LNG plants, air separation units,
                                    and large-scale petrochemical operations. Integrated control systems optimize
                                    performance across variable load conditions.
                                </p>

                                <div className="mt-8 flex justify-center">
                                    <a
                                        href="/contact"
                                        className="inline-block rounded bg-rose-600 px-8 py-3 text-md font-medium text-white transition hover:bg-rose-700 focus:outline-none focus:ring focus:ring-rose-300"
                                    >
                                        Request Engineering Package
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Axial Compressor */}
                <section data-aos="fade-left">
                    <div className="mx-auto max-w-screen-xl px-4 py-8 sm:px-6 sm:py-12 lg:px-8 lg:py-16">
                        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-16">
                            <div className="relative h-64 overflow-hidden rounded-lg sm:h-80 lg:order-first lg:h-full">
                                <img
                                    alt="Axial Flow Compressor for high-volume applications"
                                    src={Axial}
                                    className="absolute inset-0 h-full w-full object-contain" />
                            </div>

                            <div className="lg:py-16">
                                <h2 className="text-4xl text-gray-800 text-center font-bold sm:text-4xl">
                                    Axial Compressors
                                </h2>

                                <div className="my-6">
                                    <h3 className="text-xl font-semibold text-rose-600 mb-2">Key Specifications:</h3>
                                    <ul className="list-disc pl-5 text-gray-700 space-y-1">
                                        <li>Flow: 50,000-500,000 m³/h</li>
                                        <li>Pressure Ratio: Up to 15:1</li>
                                        <li>Variable stator vane technology</li>
                                        <li>Power: 5-100 MW</li>
                                    </ul>
                                </div>

                                <p className="mt-4 text-gray-600 text-lg text-justify">
                                    Engineered for extreme volume applications, our axial compressors feature
                                    multi-stage configurations with titanium alloy blades capable of withstanding
                                    high-temperature operation. Advanced CFD-designed airfoils and active clearance
                                    control systems maximize efficiency in gas turbine applications, blast furnace
                                    installations, and large HVAC systems. Optional anti-surge systems protect against
                                    damaging flow reversals.
                                </p>

                                <div className="mt-8 flex justify-center">
                                    <a href="/contact"
                                        className="inline-block rounded bg-rose-600 px-8 py-3 text-md font-medium text-white transition hover:bg-rose-700 focus:outline-none focus:ring focus:ring-rose-300">
                                        Discuss Custom Configuration
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* High Speed Reciprocating Compressor */}
                <section data-aos="fade-right">
                    <div className="mx-auto max-w-screen-xl px-4 py-8 sm:px-6 sm:py-12 lg:px-8 lg:py-16">
                        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-16">
                            <div className="relative h-64 overflow-hidden rounded-lg sm:h-80 lg:order-last lg:h-full">
                                <img alt="High-Speed Reciprocating Compressor for oil and gas applications" src={high}
                                    className="absolute inset-0 h-full w-full object-contain" />
                            </div>

                            <div className="lg:py-16">
                                <h2 className="text-4xl text-gray-800 text-center font-bold sm:text-4xl">
                                    High-Speed Reciprocating Compressors
                                </h2>

                                <div className="my-6">
                                    <h3 className="text-xl font-semibold text-rose-600 mb-2">Key Specifications:</h3>
                                    <ul className="list-disc pl-5 text-gray-700 space-y-1">
                                        <li>Speed: 900-1,800 RPM</li>
                                        <li>Pressure: Up to 10,000 PSIG</li>
                                        <li>Frame Load: 5-1,000 tons</li>
                                        <li>API 11P & 618 compliant</li>
                                    </ul>
                                </div>

                                <p className="mt-4 text-gray-600 text-lg text-justify">
                                    Our high-speed reciprocating compressors deliver exceptional reliability in critical
                                    gas injection, gas lift, and pipeline applications. Featuring modular cylinder
                                    arrangements and distance piece monitoring systems, these units are engineered for
                                    continuous operation in offshore platforms and remote gas fields. Optional
                                    proprietary valve designs extend maintenance intervals up to 16,000 operating hours.
                                </p>

                                <div className="mt-8 flex justify-center">
                                    <a
                                        href="/contact"
                                        className="inline-block rounded bg-rose-600 px-8 py-3 text-md font-medium text-white transition hover:bg-rose-700 focus:outline-none focus:ring focus:ring-rose-300"
                                    >
                                        Request API Compliance Docs
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* Oil & Gas Applications */}
            <section className="py-16 bg-gray-50">
                <div className="container mx-auto px-4">
                    <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
                        Compressor Applications in Oil & Gas
                    </h2>

                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto">
                        {[
                            {
                                title: "Gas Lift Systems",
                                content: "High-pressure compressors for enhanced oil recovery in mature fields"
                            },
                            {
                                title: "CNG Fueling Stations",
                                content: "Multi-stage compressors for vehicle natural gas refueling"
                            },
                            {
                                title: "Gas Processing",
                                content: "Centrifugal compressors for natural gas liquids extraction"
                            },
                            {
                                title: "Pipeline Transmission",
                                content: "Booster compressors for long-distance gas transportation"
                            },
                            {
                                title: "Flare Gas Recovery",
                                content: "Oil-free screw compressors capturing waste gas for reuse"
                            },
                            {
                                title: "Instrument Air Systems",
                                content: "Reliable compressed air for control valves and safety systems"
                            }
                        ].map((app, index) => (
                            <div key={index} className="bg-white p-6 rounded-lg shadow-sm">
                                <h3 className="text-xl font-bold text-rose-600 mb-3">{app.title}</h3>
                                <p className="text-gray-700">{app.content}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Enhanced Technical Support CTA */}
            <section className="py-16 bg-gradient-to-r from-rose-700 to-rose-900 text-white">
                <div className="container mx-auto px-4 text-center">
                    <div className="max-w-4xl mx-auto">
                        <h2 className="text-3xl md:text-4xl font-bold mb-6">
                            Compressor Engineering Consultation
                        </h2>
                        <p className="text-xl mb-10">
                            Our API-certified engineers provide:
                        </p>

                        <div className="grid md:grid-cols-3 gap-6 mb-12">
                            {[
                                "System Design & Layout",
                                "Performance Optimization",
                                "Retrofit & Upgrade Solutions",
                                "Troubleshooting & Diagnostics",
                                "Energy Efficiency Audits",
                                "Maintenance Planning"
                            ].map((service, index) => (
                                <div key={index} className="flex items-start">
                                    <HiOutlineBadgeCheck className="text-2xl mt-1 mr-3 text-rose-200 flex-shrink-0" />
                                    <span>{service}</span>
                                </div>
                            ))}
                        </div>

                        <div className="flex flex-col sm:flex-row justify-center gap-4">
                            <a
                                href="tel:+919819600149"
                                className="bg-white text-rose-700 hover:bg-gray-100 font-bold py-3 px-8 rounded-lg transition duration-300"
                            >
                                Call: +91 9819600149
                            </a>
                            <a
                                href="mailto:info@oilandgasindustrialequipmentsupply.com"
                                className="border-2 border-white hover:bg-rose-800 font-bold py-3 px-8 rounded-lg transition duration-300"
                            >
                                Email Technical Team
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            {/* Project Case Studies */}
            <section className="py-16 bg-white">
                <div className="container mx-auto px-4">
                    <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
                        Global Compressor Projects
                    </h2>

                    <div className="max-w-5xl mx-auto">
                        <div className="grid md:grid-cols-2 gap-8">
                            <div className="bg-gray-50 p-6 rounded-lg">
                                <h3 className="text-xl font-bold text-rose-600 mb-3">Offshore Gas Compression Platform</h3>
                                <p className="text-gray-700 mb-4">
                                    <span className="font-semibold">Location:</span> North Sea<br />
                                    <span className="font-semibold">Solution:</span> 6 × API 618 reciprocating compressors<br />
                                    <span className="font-semibold">Capacity:</span> 50 MMSCFD at 5,000 PSIG<br />
                                    <span className="font-semibold">Features:</span> Explosion-proof, marine-grade coating
                                </p>
                                <div className="flex items-center">
                                    <FaCheck className="text-green-600 mr-2" />
                                    <span>32% energy savings vs previous system</span>
                                </div>
                            </div>

                            <div className="bg-gray-50 p-6 rounded-lg">
                                <h3 className="text-xl font-bold text-rose-600 mb-3">Refinery Instrument Air System</h3>
                                <p className="text-gray-700 mb-4">
                                    <span className="font-semibold">Location:</span> Middle East<br />
                                    <span className="font-semibold">Solution:</span> Oil-free rotary screw compressors<br />
                                    <span className="font-semibold">Capacity:</span> 8,000 CFM at 125 PSIG<br />
                                    <span className="font-semibold">Features:</span> Class 0 oil-free air, integrated dryers
                                </p>
                                <div className="flex items-center">
                                    <FaCheck className="text-green-600 mr-2" />
                                    <span>99.98% uptime over 3 years</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    )
};

export default Compressors;